/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";

import logo from "../../logo.svg";
import menuSVG from "../../assets/images/sidebar/menu.svg";
import homeSVG from "../../assets/images/sidebar/home.svg";
import dataSVG from "../../assets/images/sidebar/data.svg";

import "./navbar.css";
import { NavLink } from "react-router-dom";
import { Notifications } from "../Notification/Notifications";
import { useAuth } from "../../AuthenticationStore";

const NavBar = () => {
  const { logout, user, userContext } = useAuth();

  useEffect(() => {
    //Horizontal menu in mobile
    // eslint-disable-next-line no-undef
    $('[data-toggle="horizontal-menu-toggle"]').on("click", function() {
      // eslint-disable-next-line no-undef
      $(".horizontal-menu .bottom-navbar").toggleClass("header-toggled");
    });
  }, []);

  return (
    <div className="horizontal-menu">
      <nav className="navbar top-navbar col-lg-12 col-12 p-0">
        <div className="container">
          <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
            <div className="navbar-brand brand-logo">
              <img style={{ height: "60px" }} src={logo} alt="logo" />
              <span style={{ fontSize: "15px", fontWeight: "bold" }}>
                {" "}
                &nbsp;&nbsp;Créditos{" "}
                <span style={{ color: "#26d6c4" }}>Digitales</span>
              </span>
            </div>
            <div className="navbar-brand brand-logo-mini">
              <img style={{ height: "60px" }} src={logo} alt="logo" />
            </div>
          </div>
          <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
            <ul className="navbar-nav navbar-nav-right">
              <Notifications />
              <li className="nav-item dropdown">
                <NavLink
                  className="nav-link dropdown-toggle d-flex align-items-center justify-content-center"
                  id="notificationDropdown"
                  to="/configuration/campaigns"
                >
                  <i
                    style={{ fontSize: "25px" }}
                    className="mdi mdi-cogs mx-0"
                  ></i>
                </NavLink>
              </li>

              <li className="nav-item nav-profile dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  data-toggle="dropdown"
                  id="profileDropdown-navbar"
                >
                  <i
                    style={{ fontSize: "25px" }}
                    className="mdi mdi-account mx-0"
                  ></i>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right navbar-dropdown flat-dropdown"
                  aria-labelledby="profileDropdown-navbar"
                >
                  <div className="flat-dropdown-header profile_navbar_header">
                    <div className="d-flex">
                      <div>
                        <span className="profile-name font-weight-bold">
                          <i className="fa fa-envelope-o"></i>
                          {user ? user.profile.name : ""}
                        </span>
                        {/* <p className="profile-designation"></p> */}
                      </div>
                    </div>
                  </div>
                  <div className="profile-dropdown-body profile_navbar_body">
                    <ul className="list-profile-items profile_navbar">
                      {userContext &&
                      userContext.user &&
                      [0, 1].indexOf(userContext.user.userRole) !== -1 ? (
                        <li className="profile-item">
                          <NavLink
                            to="/admin"
                            className="profile-dropdown-link"
                          >
                            <div className="d-flex align-items-center">
                              <i className="fa-lock fa text-primary"></i>
                              <div>
                                <h5 className="item-title">
                                  Administrar plataforma
                                </h5>
                              </div>
                            </div>
                          </NavLink>
                        </li>
                      ) : null}

                      <li className="profile-item">
                        <div onClick={logout} className="profile-dropdown-link">
                          <div className="d-flex align-items-center">
                            <i className="fa fa-share-square-o text-primary"></i>
                            <div>
                              <h5 className="item-title mt-0">Salir</h5>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
            <button
              className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
              type="button"
              data-toggle="horizontal-menu-toggle"
            >
              <img src={menuSVG} alt="" className="" />
            </button>
          </div>
        </div>
      </nav>
      <nav className="bottom-navbar">
        <div className="container">
          <ul
            className="nav page-navigation"
            style={{ justifyContent: "start" }}
          >
            <li className="nav-item">
              <NavLink className="nav-link" to="/indicators">
                <img src={dataSVG} alt="" className="nav-icon-title" />
                <span className="menu-title">Indicadores</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/campaigns">
                <img src={homeSVG} alt="" className="nav-icon-title" />
                <span className="menu-title">Campañas</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
